// extracted by mini-css-extract-plugin
export default {"wrap":"teacher_wrap__C8wq2","pg":"teacher_pg__iCFvY","pic":"teacher_pic__NSbmr","text":"teacher_text__CjFb4"};